export default __webpack_public_path__ + "static/media/Logo.821b488e.svg";